<template>
  <b-form>
    <b-form-group label="Название конференц-зала">
      <b-form-input v-model="model.title" @change="model.id && apply()"></b-form-input>
    </b-form-group>
    <b-row>
      <b-col cols="5">
        <b-form-group label="Изображение">
          <b-img v-if="imageURL" :src="imageURL" fluid center style="max-width: 300px; max-height: 200px;"></b-img>
          <b-img v-else blank blank-color="#777" fluid width="300" height="200"></b-img>

          <b-button size="sm" id="pick-image" class="mt-3">{{ model.image ? 'Сменить' : 'Выбрать' }}</b-button>
          <avatar-cropper :upload-handler="setImage" :cropper-options="{aspectRatio: 1.77, zoomable: false, movable: true}" trigger="#pick-image" :labels="{submit: 'Ок', cancel: 'Отмена'}"></avatar-cropper>
        </b-form-group>
      </b-col>
      <b-col cols="7">
        <!-- <b-form-group label="Описание конференц-зала" class="description">
          <text-editor v-model="model.description" @input="model.id && apply()"></text-editor>
        </!-->

        <b-form-group label="Расписание">
          <div class="d-flex flex-row justify-content-start align-items-start flex-wrap mb-3">
            <p v-for="(schedule, index) in model.schedule" :key="`schedule-${index}`" class="mr-3 mb-2">
              <span class="bg-primary p-2 mr-1 rounded small text-light">{{ schedule.weekday | printWD }}, {{ schedule.time }}</span>

              <b-button size="sm" @click="model.schedule.splice(index, 1)" variant="danger">
                <font-awesome-icon size="xs" :icon="['fas', 'trash-alt']"></font-awesome-icon>
              </b-button>
            </p>
          </div>

          <!-- <ul>
            <li v-for="(schedule, index) in model.schedule" :key="`schedule-${index}`">
              {{ schedule.weekday | printWD }}, {{ schedule.time }}
              <b-button-close size="sm" @click="model.schedule.splice(index, 1)" variant="danger">
                <font-awesome-icon size="xs" :icon="['fas', 'trash-alt']"></font-awesome-icon>
              </b-button-close>
            </li>
          </ul> -->

          <b-form v-if="showScheduleForm">
            <b-form-row>
              <b-col cols="7">
                <b-form-group label="День недели">
                  <b-form-select :options="weekdays" v-model="schedule.weekday" />
                </b-form-group>
              </b-col>
              <b-col cols="5">
                <b-form-group label="Время начала">
                  <b-form-select :options="times" v-model="schedule.time" />
                </b-form-group>
              </b-col>
            </b-form-row>
          </b-form>

          <b-button v-if="!showScheduleForm" size="sm" variant="secondary" @click="addSchedule()" class="mr-1">Еще одно время начала</b-button>
          <b-button v-if="showScheduleForm" size="sm" @click="saveSchedule()">Добавить</b-button>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Приветствие при входе в конференц-зал">
          <b-form-textarea v-model="model.welcome" @change="model.id && apply()" />
        </b-form-group>
      </b-col>
    </b-row>

    <slot name="form-footer" :apply="apply" :room="model" />
  </b-form>
</template>

<script>
// import TextEditor from '@/components/Editor'
import AvatarCropper from 'vue-avatar-cropper'

export default {
  components: {
    // TextEditor,
    AvatarCropper
  },
  filters: {
    printWD (d) {
      const w = {
        1: 'Понедельник',
        2: 'Вторник',
        3: 'Среда',
        4: 'Четверг',
        5: 'Пятница',
        6: 'Суббота',
        7: 'Воскресенье'
      }
      return w[d]
    }
  },
  props: {
    room: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    model: null,
    cropper: null,
    imageURL: null,
    weekdays: [
      { value: 1, text: 'Понедельник' },
      { value: 2, text: 'Вторник' },
      { value: 3, text: 'Среда' },
      { value: 4, text: 'Четверг' },
      { value: 5, text: 'Пятница' },
      { value: 6, text: 'Суббота' },
      { value: 7, text: 'Воскресенье' }
    ],
    showScheduleForm: true,
    schedule: {
      weekday: 1,
      time: '18:00'
    }
  }),
  computed: {
    times () {
      let times = []
      for (let h = 0; h < 24; h++) {
        for (let m = 0; m < 60; m += 5) {
          let time = ('00'.substring(0, 2 - ('' + h).length) + h) + ':' + ('00'.substring(0, 2 - ('' + m).length) + m)
          times.push({
            value: time,
            text: time
          })
        }
      }
      return times
    }
  },
  beforeMount () {
    this.model = this.room
    if (this.model.id) {
      this.showScheduleForm = false
    }

    this.setPreviewImage()
  },
  methods: {
    setPreviewImage () {
      if (typeof this.model.image === 'string' && !!this.model.image) {
        this.imageURL = 'https://api.evangelie.life/' + this.model.image
      } else if (this.model.image) {
        let reader = new FileReader()
        reader.onload = (e) => {
          this.imageURL = e.target.result
        }
        reader.readAsDataURL(this.model.image)
      }
    },
    setImage (cropper) {
      cropper.getCroppedCanvas().toBlob(blob => {
        this.model.image = blob
        this.setPreviewImage()
      })
    },
    sortSchedule (a, b) {
      const w = a.weekday - b.weekday

      if (w) {
        return w
      }

      const at = parseInt(a.time.replace(':', ''))
      const bt = parseInt(b.time.replace(':', ''))

      return at - bt
    },
    addSchedule () {
      this.showScheduleForm = true
    },
    saveSchedule () {
      const exists = this.model.schedule.reduce((exists, schedule) => {
        console.log('new', this.schedule.weekday, this.schedule.time)
        console.log('old', schedule.weekday, schedule.time)
        if ((this.schedule.weekday === schedule.weekday) && (this.schedule.time === schedule.time)) {
          return true
        }

        return exists || false
      }, false)
      if (exists) {
        this.$bvToast.toast('Такое время уже есть в расписании!', {
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true
        })
        return
      }
      this.model.schedule.push({ ...this.schedule })
      this.showScheduleForm = false
    },
    removeSchedule (index) {
      this.model.schedule.splice(index, 1)
    },
    apply () {
      this.$emit('apply', this.model)
    }
  }
}
</script>

<style lang="scss">
.description {
  .ck-editor {
    .ck-content {
      height: 6rem;
    }
  }
}
</style>
